/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setStoryProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import StoryCTA from 'material/embeds/content/shared/storycta/storycta';



/* ========== ~~~~~~~~~~ EMBED : STORY CTA : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => ({
    embedLocationType: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
    ctaText: embedsState.embedManagementState.contentStatus.contents[contentId]['story']['ctaText'],
    isValid: embedsState.embedManagementState.contentStatus.contents[contentId]['story']['isCTAValid']
});


const mapDispatchToProps = dispatch => ({
    setStoryProperty: (contentId, property, value) => dispatch(setStoryProperty(contentId, property, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StoryCTA);
